export function formatToNDecimalPlaces(input,fixed=2) {
    const num = parseFloat(input);
    if (isNaN(num)) {
      throw new Error("Input must be a number or a string representing a number");
    }
    return num.toFixed(fixed);
  }
  